import { SearchLinkGenerator } from '../apps/url/generators/SearchLinkGenerator'
import { SearchFiltersUrl } from '../apps/url/search-filters/SearchFiltersUrl'
import { Route } from '~/apps/pu-links/domain/Route'
import { GeoCoordinates } from './geolocation/schema'

export default function generateNearMeUrl(
  category: string,
  query: Route['query'],
  point: GeoCoordinates,
) {
  const urlGenerator = new SearchLinkGenerator()
  const area = {
    lat: point.lat,
    lng: point.lng,
    rangeMiles: Number(process.env.defaultWithinRange || 15),
    isEmptyPoint: false,
  }
  return urlGenerator.getUrlData({
    category,
    excludeType: 'nearMe',
    filters: {
      ...SearchFiltersUrl.urlToFilters(query),
      area,
    },
  })
}
